import React from "react";
import NotesIcon from "@material-ui/icons/Notes";
function Header() {
  return (
    <div>
      <header>
        <NotesIcon /> Keeper
      </header>
    </div>
  );
}

export default Header;
